"use client";

import { useFormStatus } from "react-dom";

import cn from "classnames";

import { Button } from "@/components/button/button.component";

import { brown } from "@/app/font";
import { RecommendedMonitoringPlansQueryResult } from "@/sanity.types";

import { Plan } from "./monitoringPlanDrawerContent.component";

export const MonitoringPlanDrawerAction = ({
  plans,
  selectedPlan,
}: MonitoringPlanDrawerActionType) => {
  const { pending } = useFormStatus();
  return (
    <Button
      secondary
      data-testid="save-plan-button"
      loading={pending}
      disabled={plans.length === 0 || !selectedPlan?.id || pending}
      aria-disabled={plans.length === 0 || !selectedPlan?.id || pending}
      aria-busy={pending}
      className={cn(
        brown.className,
        "w-full cursor-pointer px-6 py-3 md:w-auto",
      )}>
      Save my plan
    </Button>
  );
};

export type MonitoringPlanDrawerActionType = {
  plans: RecommendedMonitoringPlansQueryResult;
  selectedPlan: Plan | null;
};
